import { LazyImage } from '@components/common/image'
import classNames from 'classnames'
import React from 'react'

type ImageType = {
  fileName: string
  className?: any
  alt?: string
}
type BackgroundProps = {
  children?: React.ReactNode
  rootChildren?: React.ReactNode
  basePath?: string
  images: ImageType[]
  className?: any
  contentClassName?: any
}
const Background = ({
  children,
  className,
  images,
  basePath,
  rootChildren,
  contentClassName,
}: BackgroundProps) => {
  return (
    <section className={classNames('relative overflow-hidden', className)}>
      {rootChildren}
      {images.map((image) => (
        <LazyImage
          key={image.fileName}
          className={classNames(
            'absolute z-10 opacity-75 max-h-full',
            image.className
          )}
          path={basePath}
          alt={image.fileName || image.alt}
          name={image.fileName}
        />
      ))}

      <div className={classNames('relative z-20', contentClassName)}>
        {children}
      </div>
    </section>
  )
}

export default Background
